import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Col, Row } from "react-bootstrap";
import { Eye, Gear, Pen, Pencil, Trash } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import EditClaimServicesModal from "./EditClaimServicesModal";
import {
  handleAddClaimServices,
  setSelectedService,
  setHistoryModal,
  setViewModal,
  setEditModal,
} from "features/cliams/config/claimSlice";
import ClaimMedicalHistoryModal from "./create-claim/components/ClaimMedicalHistoryModal";
import { MdDelete } from "react-icons/md";
import moment from "moment";

const ServiceInformationDetails = ({ services = [] }) => {
  const dispatch = useDispatch();
  const { historyModalOpen, viewClaimInfo } = useSelector(
    (state) => state.claim,
  );
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [preauthUpdates, setPreauthUpdates] = useState({});

  const editModal = (id, row) => {
    dispatch(setSelectedService(row));
    dispatch(setHistoryModal(true));
    dispatch(setEditModal(true));
    setShowModal(true);
  };
  const viewModal = (id, row) => {
    dispatch(setSelectedService(row));
    dispatch(setHistoryModal(true));
    dispatch(setViewModal(true));
    setShowModal(true);
  };
  const status = viewClaimInfo?.claim_status;

  const isDisabled =
    status?.toLowerCase() === "invalid" ||
    status?.toLowerCase() === "valid" ||
    status?.toLowerCase() === "invalid" ||
    status?.toLowerCase() === "in process" ||
    status?.toLowerCase() === "rejected" ||
    status?.toLowerCase() === "cancelled";

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (deleteId) {
      dispatch(
        handleAddClaimServices({
          type: "DELETE_SERVICES",
          payload: { id: deleteId },
        }),
      );
    }
    setShowDeleteModal(false);
    setDeleteId(null);
  };
  const handlePreauthRefNoChange = (id, value) => {
    setPreauthUpdates((prev) => ({
      ...prev,
      [id]: value,
    }));
    dispatch(
      handleAddClaimServices({
        type: "UPDATE_PREAUTH_REF_NO",
        payload: { id, preauthorization_ref_no: value },
      }),
    );
  };
  const columns = [
    {
      name: <div className="fs-12">Service Code / Description</div>,
      sortable: false,
      omit: false,
      cell: (row) => {
        const code =
          row?.service_code_description?.value ||
          row?.service_code_description?.prodserv_code;
        const desc =
          row?.service_code_description?.label ||
          row?.service_code_description?.prodserv_desc;
        const providerCode = row?.service_code_description?.provider_code;
        const providerDesc = row?.service_code_description?.provider_codedesc;

        return (
          <div className="fs-12">
            <div className="text-warning">
              <strong>{code}</strong> - {desc}
            </div>
            {(providerCode || providerDesc) && (
              <div className="text-primary">
                {providerCode || ""} - {providerDesc || ""}
              </div>
            )}
          </div>
        );
      },
      width: "150px",
    },
    {
      name: <div className="fs-12">Date</div>,
      sortable: false,
      omit: false,
      selector: (row) => (
        <div className="fs-12">
          {row?.service_start_date
            ? moment(row?.service_start_date).format("DD-MM-YYYY")
            : "" || ""}
        </div>
      ),
    },
    {
      name: <div className="fs-12">Preauth Ref No</div>,
      sortable: false,
      cell: (row) => (
        <div className="fs-12">{row?.preauthorization_ref_no || ""}</div>
      ),
      width: "150px",
    },
    {
      name: <div className="fs-12"> Invoice No </div>,
      selector: (row) => <div className="fs-12"> {row.invoice_no} </div>,
      center: true,
    },
    {
      name: <div className="fs-12">Price</div>,
      selector: (row) => row.unit_price,
      cell: (row) => (
        <div className="fs-12">{`${Number(
          row.unit_price,
        ).toLocaleString()}`}</div>
      ),
      center: true,
      width: "100px",
    },
    {
      name: <div className="fs-12">Quantity</div>,
      selector: (row) => <div className="fs-12"> {row.quantity} </div>,
      center: true,
      width: "100px",
    },
    {
      name: <div className="fs-12">Net Amount</div>,
      selector: (row) => row.net_amount,
      cell: (row) => (
        <div className="fs-12">{`${Number(
          row.net_amount,
        ).toLocaleString()}`}</div>
      ),
      center: true,
      width: "120px",
    },
    {
      name: <div className="fs-12">VAT</div>,
      selector: (row) => row.vat,
      cell: (row) => <div className="fs-12">{`${row.vat}%`}</div>,
      center: true,
      width: "80px",
    },
    {
      name: <div className="fs-12">Discount</div>,
      selector: (row) => row.discount,
      cell: (row) => (
        <div className="fs-12">{`${Number(
          row.discount,
        ).toLocaleString()}`}</div>
      ),
      center: true,
      width: "120px",
    },
    {
      name: <Gear />,
      button: true,
      allowOverflow: true,
      cell: (row) =>
        isDisabled ? (
          <div className="d-flex align-items-center gap-3 cursor-pointer">
            <Eye
              className="text-primary"
              size={12}
              onClick={() => viewModal(row.id, row)}
            />
            <Pen
              className="text-warning"
              size={12}
              onClick={() => editModal(row.id, row)}
            />
            <MdDelete
              className="text-danger"
              size={12}
              onClick={() => handleDeleteClick(row.id)}
            />
          </div>
        ) : (
          <div className="d-flex align-items-center gap-3 cursor-pointer">
            <Eye
              className="text-primary"
              size={12}
              onClick={() => viewModal(row.id, row)}
            />
          </div>
        ),
      width: "120px",
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#2c7be5",
        color: "white",
        fontWeight: "bold",
      },
    },
    headCells: {
      style: {
        fontSize: "0.85rem",
        padding: "8px",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        fontSize: "0.85rem",
        padding: "8px",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #e3ebf6",
        "&:hover": {
          backgroundColor: "#f8f9fa",
        },
      },
    },
  };

  return (
    <Row>
      <Col xs={12} className="border-0  shadow-sm">
        <DataTable
          columns={columns}
          data={services}
          customStyles={customStyles}
          dense
          responsive
          noHeader
        />
      </Col>

      <ClaimMedicalHistoryModal
        show={historyModalOpen}
        onHide={() => dispatch(setHistoryModal(false))}
      />

      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this service?"
      />
    </Row>
  );
};

export default ServiceInformationDetails;
